import DragViewState from '../store/schema/DragViewState';
import { action } from 'satcheljs/lib/legacy';

// Set Drag state, should be called only from Draggable component
export default action('setDragState')(function(
    viewState: DragViewState,
    isBeingDragged: boolean
): void {
    viewState.isBeingDragged = isBeingDragged;
});
